export default {
  handler: 'relativeUrl',
  data: ({ casinoCategory }) => `/casino/category/${casinoCategory}`,
};
